import type { ReactElement } from "react";
import { Container, SimpleGrid } from "@chakra-ui/react";
import type { ContainerProps, GridProps } from "@chakra-ui/react";

interface ProfileBodyProps extends ContainerProps {
  /**
   * Props to apply to the inner `SimpleGrid` component
   */
  gridProps?: GridProps;
  /**
   * The total columns to use for the grid layout
   *
   * @defaultValue `12`
   */
  columns?: number;
  /**
   * The gap between the profile cards on the page
   *
   * @defaultValue `4`
   */
  gap?: number;
}

const ProfileBody = ({
  children,
  columns = 12,
  gap = 4,
  gridProps,
  ...props
}: ProfileBodyProps): ReactElement => (
  <Container maxW="8xl" py={4} {...props}>
    <SimpleGrid gap={gap} columns={columns} {...gridProps}>
      {children}
    </SimpleGrid>
  </Container>
);

export default ProfileBody;
